import {Icon} from '@components/@icons';
import {CheckboxProps, Checkbox as MUICheckbox} from '@mui/material';
import classNames from 'classnames';
import {FC, forwardRef} from 'react';
import styles from './MeinCheckbox.module.css';

export const MeinCheckbox: FC<CheckboxProps> = forwardRef(function MeinCheckbox(
    {className, ...rest},
    ref,
) {
    return (
        <MUICheckbox
            disableTouchRipple
            icon={<Icon name="square" className={styles.icon} />}
            checkedIcon={<Icon name="check-square" className={styles.icon} />}
            ref={ref}
            className={classNames(className)}
            {...rest}
        />
    );
});
